/**
 * BestWorstTrial
 * --------------
 *
 * September 2026
 *
 * Renders the best/worst trial comparison from a doe_result's _metadata
 * (best_trial/worst_trial -- see experiment_chart.py's get_summary_metadata()).
 * Unlike every other chart tab, this data isn't a Plotly {data, layout}
 * object under a top-level doe_result key, so it can't go through the
 * generic renderChart() dispatcher -- it needs its own presentation.
 */
function renderMetricRows(trial) {
  return Object.keys(trial)
    .filter((key) => key !== "trial_number" && key !== "parameters")
    .map((key) => (
      <tr key={key}>
        <td style={{ padding: "0.3rem 0.6rem", color: "#666" }}>{key}</td>
        <td style={{ padding: "0.3rem 0.6rem", fontWeight: 600 }}>
          {typeof trial[key] === "number" ? trial[key].toLocaleString() : String(trial[key])}
        </td>
      </tr>
    ));
}

function TrialCard({ label, trial }) {
  if (!trial) return null;
  const parameters = trial.parameters || {};

  return (
    <div
      style={{
        flex: 1,
        minWidth: 280,
        border: "1px solid #dee2e6",
        borderRadius: 4,
        padding: "1rem",
      }}
    >
      <h4 style={{ marginTop: 0, marginBottom: "0.75rem" }}>
        {label} (trial #{trial.trial_number})
      </h4>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "0.75rem" }}>
        <tbody>{renderMetricRows(trial)}</tbody>
      </table>
      {Object.keys(parameters).length > 0 && (
        <>
          <div style={{ fontSize: "0.85rem", color: "#666", marginBottom: "0.25rem" }}>Parameters</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              {Object.entries(parameters).map(([key, value]) => (
                <tr key={key}>
                  <td style={{ padding: "0.2rem 0.6rem", fontSize: "0.85rem", color: "#666" }}>{key}</td>
                  <td style={{ padding: "0.2rem 0.6rem", fontSize: "0.85rem" }}>
                    {typeof value === "number" ? value.toLocaleString() : String(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default function BestWorstTrial({ metadata }) {
  const best = metadata?.best_trial;
  const worst = metadata?.worst_trial;

  if (!best && !worst) {
    return (
      <div style={{ padding: "1rem", color: "#999" }}>No data available for Best/Worst Trial</div>
    );
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", padding: "0.5rem" }}>
      <TrialCard label="Best Trial" trial={best} />
      <TrialCard label="Worst Trial" trial={worst} />
    </div>
  );
}
